import styled from "styled-components/macro";
import { Popup } from "react-map-gl";

import { borderRadius, colors, space, fontStyle, fontSize } from "shared/styles/constants";

export const PopupTitle = styled.span`
  ${fontStyle.bold}
  ${fontSize.base}
`;

export const StyledPopup = styled(Popup)`
  color: ${colors.black};
  min-width: 200px;
  cursor: auto;

  .mapboxgl-popup-content {
    border-radius: ${borderRadius.m};

    padding: ${space.m};

    ${fontSize.xs};
  }
`;
